import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { Item as dxListItem, ItemClickEvent } from 'devextreme/ui/list';
import { ValueChangedEvent as NumberBoxValueChangeEvent } from 'devextreme/ui/number_box';

import { NextPimField } from 'app/Model/Catalog/NextPimField';
import { fieldNames } from 'app/Model/FieldNames';
import { TemplateService } from 'app/Services/template.service';
import { TemplateItem } from 'app/Model/Catalog/TemplateItem';
import { comparePimFields, fillLastKey, isNextPimField, parsePimField } from 'app/Services/templateItemHelpers';
import { HazmatClass } from 'app/Model/Catalog/HazmatClass';
import { WarrantyClass } from 'app/Model/Catalog/WarrantyClass';
import { TemplateItemTemplate } from '../../Model/Catalog/TemplateItemTemplate';
import { DxDropDownBoxComponent } from 'devextreme-angular';
import {SelectionChangedEvent} from "devextreme/ui/select_box";
import {TemplateFieldsService} from "../../Services/templateFields.service";
import {LoginService} from "../../Services/login.service";

@Component({
    selector: 'np-advanced-template-legal',
    templateUrl: './advanced-template-legal.component.html',
    standalone: false
})
export class AdvancedTemplateLegalComponent implements OnInit {
  @Input() templateItem!: TemplateItem;
  @Input() pimField!: NextPimField;

  @Input() warrantyClasses: WarrantyClass[] = [];
  @Input() hazmatClasses: HazmatClass[] = [];
  @Output() onUpdate = new EventEmitter<void>();

  fieldList: TemplateItemTemplate[] = this.fieldService.legalFields;

  get isRadioGroupItem() {
    return this.pimField.field !== fieldNames.hazmatClassNew && this.pimField.field !== fieldNames.warrantyClassNew;
  }

  get isHazmatClass() {
    return this.pimField.field === fieldNames.hazmatClassNew;
  }

  get isWarrantyClass() {
    return this.pimField.field === fieldNames.warrantyClassNew;
  }

  constructor(private templateService: TemplateService, private fieldService: TemplateFieldsService, private loginService: LoginService) {
  }

  ngOnInit() {
    this.pimField.systemKey = '-1';
    this.pimField.elementKey = '-1';
  }

  getFieldDisplayExpr(item: TemplateItemTemplate) {
    return item?.text === item?.field ? item?.field ?? '' : `${item.text} (${item.field})`;
  }

  update() {
    const { field, systemKey, elementKey } = this.pimField;
    const parsedKey = parsePimField(this.templateItem.key);
    if (parsedKey !== null && (comparePimFields(parsedKey, this.pimField) || !isNextPimField(parsedKey.field))) {
      this.onUpdate.emit();
      return;
    }
    this.templateService.getHeadline(field, elementKey, systemKey, this.loginService.currentCustomer.id).subscribe((headline) => {
      fillLastKey(this.templateItem, headline.value);
      this.onUpdate.emit();
    });
  }
}
